import { PRODUCTS } from './constants';

export function getProduct(itemName) {
  let products = {};

  const res = browse(PRODUCTS, itemName);
  products = res ? res : 'none';
  return products;
}

function browse(tree, itemName) {
  if (itemName === 'configure') return tree;
  for (let k in tree) {
    if (k === itemName) {
      return tree[k];
    }
    let found = null;
    if (isTree(tree[k])) {
      found = browse(tree[k], itemName);
    }
    if (found) {
      return found;
    }
  }
}

function isTree(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}

export const createOrder = async (attr, type = null) => {
  const apiRoot = `https://mythreekit.com/api/organizations/masa/orders`;
  if (type) {
    attr.type = type;
  }
  const result = await fetch(apiRoot, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(attr),
  }).then(async res => {
    if (res.status === 200) return await res.json();
    return null;
  });
  return result;
};



// WEBPACK FOOTER //
// ./src/modules/helper.js